import React from "react";

import Image from "next/image";

import FigureImage from "public/images/enerflo-solar-platform-document-signing-contracting.png";

import Heading from "components/heading";

import HeroSection from "../../hero-section";

const title = "Complex Solar Contracts, Simplified";

const MainHero = () => (
  <HeroSection title={title} className="flex-col md:flex-row">
    <HeroSection.Content className="md:w-1/2">
      <HeroSection.Header className="md:items-start">
        <Heading tag="h1">{title}</Heading>
      </HeroSection.Header>
      <HeroSection.Description>
        Enerflo’s proprietary Docflo platform is docsigning, reimagined. Purpose-built for solar, Docflo intelligently
        serves up the right docs at the right time, with tons of useful features baked right in. You’ll never want to
        sign on another platform again.
      </HeroSection.Description>
    </HeroSection.Content>

    <figure className="p-3 w-full xs:w-4/5 sm:w-3/4 md:w-1/2">
      <Image
        src={FigureImage}
        alt="Enerflo’s proprietary doc signing solution for solar, Docflo, intelligently serves up the right docs at the right time, limiting change orders and improving upstream data."
        layout="responsive"
        quality={100}
        placeholder="blur"
        loading="eager"
        priority
        className="crispImage"
        sizes="(min-width: 768px) 50vw, 100vw"
      />
    </figure>
  </HeroSection>
);

export default MainHero;
